import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input } from '../index';
import { useTranslation } from 'react-i18next';
import SearchIcon from 'assets/svgs/searchIcon.svg';
import { uniqueId } from 'lodash';

import './SearchForm.scss';

const SearchForm = (props) => {
  const { t } = useTranslation();
  const onSearch = (e) => {
    if (e.key === 'Enter' || e.type === 'click') {
      props.onSearch();
    }
  };
  const { customButton } = props;
  const buttonText = customButton ?? t('common.labels.search');
  const errorClass = props.hasFloatingError ? 'floating-error-container' : '';

  return (
    <div className={`search-form-container ${props.className} ${errorClass}`}>
      <div className="input-search-container">
        <Input
          type="text"
          name="searchInput"
          id={uniqueId('search-input')}
          value={props.searchValue}
          placeholder={props.placeholder}
          onChange={props.onChange}
          onKeyPress={onSearch}
          errors={props.errors}
          clearValue={props.clearSearch}
          autocomplete={props.autocomplete}
        />
        <button
          className={`btn btn-action btn-search btn-small ${
            props.displayIconButton ? 'btn-search-with-icon' : ''
          }`}
          onClick={onSearch}>
          {props.displayIconButton ? <SearchIcon /> : buttonText}
        </button>
      </div>
    </div>
  );
};

export default SearchForm;

SearchForm.propTypes = {
  displayIconButton: PropTypes.bool,
  customButton: PropTypes.string,
  clearSearch: PropTypes.func,
  autocomplete: PropTypes.bool,
  hasFloatingError: PropTypes.bool,
};

SearchForm.defaultProps = {
  displayIconButton: true,
  autocomplete: true,
  hasFloatingError: false,
};
